import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";

const AccountDropdown = ({ user, onClose, onLogout }) => {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 z-50 flex justify-center items-start">

      {/* BACKDROP */}
      <div
        onClick={onClose}
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
      />

      {/* CARD */}
      <div
        className="
          relative mt-20
          bg-white/90 backdrop-blur-xl
          w-[95%] sm:w-[550px]
          rounded-2xl
          shadow-2xl
          px-6 py-6
          animate-[fadeIn_0.3s_ease]
        "
      >
        {/* CLOSE */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-red-500 transition"
        >
          <X size={22} />
        </button>

        {/* TITLE */}
        <h2 className="text-center text-teal-700 font-semibold text-lg mb-6">
          Your Account
        </h2>

        <div className="flex gap-6">

          {/* LEFT PROFILE */}
         <div className="w-[40%] text-center">
  <div
    className="w-20 h-20 mx-auto rounded-full flex items-center justify-center shadow-inner"
    style={{ backgroundColor: "#187685" }} // ✅ custom color
  >
    {/* ✅ White letter */}
    <span className="text-3xl font-bold text-white uppercase">
      {(user?.email || "U").charAt(0)}
    </span>
  </div>

  <h3 className="mt-3 font-semibold text-gray-800 text-base">
    {user?.name || "User"}
  </h3>

  <p className="text-sm text-gray-500 break-all mt-1">
    {user?.email || user?.phone}
  </p>

  <button
    onClick={() => {
      onClose();
      navigate("/edit-profile");
    }}
    className="mt-4 px-5 py-2 text-sm rounded-lg 
    bg-teal-600 text-white 
    hover:bg-teal-700 transition shadow-md"
  >
    Edit Profile →
  </button>
</div>

          {/* DIVIDER */}
          <div className="w-px bg-gray-200" />

          {/* RIGHT MENU */}
          <div className="flex-1 text-sm text-gray-700 py-2">

            {[
              { label: "My Orders", section: "orders" },
              { label: "My Wishlist", section: "wishlist" },
              { label: "My Address", section: "addressinfo" },
              { label: "Need Help ?", section: "faq" },
            ].map((item, i) => (
              <div
                key={i}
                onClick={() => {
                  onClose();
                  navigate("/edit-profile", {
                    state: { section: item.section },
                  });
                }}
                className="
                  px-3 py-2 my-1 rounded-lg
                  cursor-pointer
                  hover:bg-teal-50 hover:text-teal-700
                  transition flex justify-between items-center
                "
              >
                {item.label}
                <span className="text-gray-400">→</span>
              </div>
            ))}

            {/* LOGOUT */}
            <button
              onClick={onLogout}
              className="
                w-full mt-4 py-2 rounded-lg
                bg-red-50 text-red-500
                hover:bg-red-100 transition
              "
            >
              Logout
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AccountDropdown;